import { api } from '@/services';
import type {
  SegregacaoCalcularPayload,
  SegregacaoCalcularResponse,
  SegregacaoDetalharPayload,
  SegregacaoDetalharResponse,
  SegregacaoAlterarStatusPayload,
  SegregacaoDetalharAgrupadoPayload,
  SegregacaoDetalharAgrupadoItem,
  XmlConvertidoPayload,
  XmlConvertidoItem,
} from './types';

export async function fetchSegregacaoCalcular(
  payload: SegregacaoCalcularPayload
): Promise<SegregacaoCalcularResponse> {
  return api.post<SegregacaoCalcularResponse, SegregacaoCalcularPayload>(
    'TurboPro/SimplesNacional/CalcularSegregacao',
    payload
  );
}

export async function fetchSegregacaoDetalhar(
  payload: SegregacaoDetalharPayload
): Promise<SegregacaoDetalharResponse> {
  return api.post<SegregacaoDetalharResponse, SegregacaoDetalharPayload>(
    'Segregacao/Detalhar',
    payload
  );
}

export async function alterarStatusSegregacao(
  payload: SegregacaoAlterarStatusPayload
): Promise<{ status: { resultado: boolean; mensagem: string } }> {
  return api.post('Doc/SegregacaoAlterarStatus', payload);
}

export async function fetchDetalharAgrupado(payload: SegregacaoDetalharAgrupadoPayload): Promise<{
  status: { resultado: boolean; mensagem: string };
  data: SegregacaoDetalharAgrupadoItem[];
}> {
  return api.post('Segregacao/DetalharAgrupado', payload);
}

export async function buscaNotasXMLConvertido(
  payload: XmlConvertidoPayload
): Promise<{ status: { resultado: boolean; mensagem: string }; data: XmlConvertidoItem[] }> {
  const params = new URLSearchParams({
    CnpjContribuinte: payload.CnpjContribuinte,
    Ano: payload.Ano,
    Mes: payload.Mes,
  });
  return api.get(`Segregacao/BuscaNotasXMLConvertido?${params}`);
}

export async function enviaNotasXMLConvertido(
  payload: XmlConvertidoPayload
): Promise<{ status: { resultado: boolean; mensagem: string }; data: unknown }> {
  return api.post('Segregacao/EnviaNotasXMLConvertido', payload);
}
